// CupiGuide.jsx
import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import styles from "./CupiGuide.module.css";
import companyStore from "../../Store/Store";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const CupiGuide = observer(() => {
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState(null);
  const FileName =
    companyStore.userType == "PineLabUser" ? "/CUPI_product_guidePine.pdf" : "/CUPI_product_guideAxis.pdf";
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function DownloadPdf() {
    try {
      const link = document.createElement("a");

      // Path to your PDF in public/ folder
      link.href = FileName; // ← correct for static/public files

      // This sets the exact name users will see in their downloads
      link.download = "CUPI - Product Guide.pdf"; // ← custom name with space & dash

      // No target="_blank" needed for download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);

      console.log(
        "PDF download triggered successfully as 'CUPI - Product Guide.pdf'",
      );
    } catch (error) {
      console.error("Error triggering PDF download:", error);
      // Optional: show user feedback
      alert("Failed to start download. Please try again.");
    }
  }
useEffect(()=>{
    // if(companyStore.userType != "PineLabUser"){
    //     navigate("/content/transactions")
    // }
},[companyStore.refresh])
  return (
    <div className={styles.CupiGuideConatiner}>
      <div className={styles.CupiGuideHeader1}>
        <div className={styles.CupiGuideHeader1Head}>CUPI guide</div>
        <div className={styles.CupiGuideHeader1Text}>
          Your go-to guide with step-by-step help on onboarding, exploring key
          features, and using CUPI smoothly.
        </div>
      </div>

      <div className={styles.CupiGuideHeader2}>
        <div className={styles.CupiGuideHeader2innerContainer}>
          <img
            className={styles.personVcardIcon}
            src="/CupiGuideIcon.svg"
            alt=""
          />
          <div className={styles.CupiGuideHeader2innerContainerText}>
            <div className={styles.CupiGuideHeader2innerContainerText1}>
              CUPI Guide
            </div>
            <div>9.6MB</div>
          </div>
        </div>
        <div>
          <button
            className={styles.CupiGuideDownloadBTN}
            onClick={() => {
              DownloadPdf();
            }}
          >
            <img
              className={styles.personVcardIcon1}
              src="/WhiteDownload.svg"
              alt=""
            />
            Download PDF
          </button>
        </div>
      </div>

      {/* Scrollable viewer – now allows horizontal scroll if PDF is wide */}
      <div
        style={{
          width: "100%",
          maxWidth: "100%", // full available width
          margin: "0 auto 20px",
          padding: "16px 0",
          background: "#f8f9fa",
          borderRadius: "12px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          overflow: "auto", // vertical + horizontal scroll
          maxHeight: "calc(100vh - 180px)", // adjust based on your headers + footer
          boxSizing: "border-box",
        }}
      >
        <Document
          file={FileName}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(error) => console.error("PDF load error:", error)}
          loading={
            <div
              style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.3rem",
                color: "#555",
              }}
            >
              Loading document...
            </div>
          }
          noData={
            <div
              style={{ padding: "2rem", textAlign: "center", color: "#d32f2f" }}
            >
              No PDF available
            </div>
          }
        >
          {numPages && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // centers each page
                gap: "40px", // more breathing room between pages
                padding: "0 16px", // small side padding inside
                minWidth: "fit-content", // prevents shrinking below natural size
              }}
            >
              {Array.from({ length: numPages }, (_, index) => (
                <div
                  key={`page-${index + 1}`}
                  style={{
                    background: "#fff",
                    borderRadius: "8px",
                    overflow: "visible", // changed from hidden → prevents internal crop
                    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                    width: "fit-content", // key: lets page take natural width
                    maxWidth: "none", // remove any artificial max
                    minWidth: "0",
                  }}
                >
                  <Page
                    pageNumber={index + 1}
                    renderTextLayer={true}
                    renderAnnotationLayer={true}
                    scale={0.8} // explicit natural scale (default anyway)
                    // width={undefined}      // no width = natural size
                    // If still too wide on mobile → you can add media query or optional responsive scale
                  />
                </div>
              ))}
            </div>
          )}
        </Document>
      </div>
    </div>
  );
});

export default CupiGuide;
